var ckDocReady = function ckDocReady(fn) {
  // see if DOM is already available
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fn);
  } else {
    setTimeout(fn, 1);
  }
};

var ckCustomerRedirect = function ckCustomerRedirect() {
  let registerAccount = document.getElementById('registerAccount');
  if (!registerAccount) return;
  const currentRegisterURL = registerAccount.getAttribute('href');

  console.log(registerAccount);
  console.log(currentRegisterURL);
}

ckDocReady(ckCustomerRedirect);